<script setup>
import 'vue3-carousel/dist/carousel.css'
import '@/assets/custom_carousel.css'
import { Carousel, Slide, Pagination } from 'vue3-carousel'
</script>
<template>
  <section class="home--blocks">
    <div class="home--blocks-wrapper">
      <div class="home--blocks-titles">
        <div class="home--block-title">
          {{ $t('home_blocks.title') }}
          <span class="primary-color">
            {{ $t('home_blocks.title_branding') }}
          </span>
        </div>
        <div class="home--block-subtitle">
          {{ $t('home_blocks.subtitle') }}
        </div>
      </div>
      <div
        class="home--blocks-row home--blocks-desktop row"
        data-aos="fade"
        data-aos-easing="linear"
        data-aos-duration="1100"
      >
        <div class="col-lg-4">
          <div class="home--block-wrapper blocks-small">
            <div class="block-header-wrapper">
              <div class="block-header">
                <div class="block-title">
                  <div class="car-text">
                    <span class="primary-color"> car </span>
                    {{ $t('home_blocks.appointment') }}
                  </div>
                </div>
                <div class="block-subtitle">
                  {{ $t('home_blocks.appointment_text') }}
                </div>
              </div>
            </div>
            <div
              class="block-body"
              :style="{ backgroundImage: 'url(assets/home/blocks/cita.webp)' }"
            >
              <button>
                <span class="fa-layers fa-fw">
                  <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                  <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                </span>
              </button>
              <div class="card-back">
                <div class="card-back-wrapper">
                  <div class="card-back-row">
                    <span class="text-bold">
                      {{ $t('home_blocks.appointment_back_text_1') }}
                    </span>
                    {{ $t('home_blocks.appointment_back_text_1_more') }}
                  </div>
                  <div class="card-back-row">
                    <span class="text-bold">
                      {{ $t('home_blocks.appointment_back_text_2') }}
                    </span>
                    {{ $t('home_blocks.appointment_back_text_2_more') }}
                  </div>
                  <div class="card-back-row">
                    <span class="text-bold">
                      {{ $t('home_blocks.appointment_back_text_3') }}
                    </span>
                    {{ $t('home_blocks.appointment_back_text_3_more') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home--block-wrapper second-block blocks-small">
            <div class="block-header-wrapper">
              <div class="block-header">
                <div class="block-title">
                  <div class="car-text">
                    <span class="primary-color"> car </span>
                    {{ $t('home_blocks.close_or') }}
                  </div>
                </div>
                <div class="block-subtitle">
                  {{ $t('home_blocks.close_or_text') }}
                </div>
              </div>
            </div>
            <div
              class="block-body"
              :style="{ backgroundImage: 'url(assets/home/blocks/cita3.webp)' }"
            >
              <button>
                <span class="fa-layers fa-fw">
                  <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                  <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                </span>
              </button>
              <div class="card-back">
                <div class="card-back-wrapper pt-2">
                  <div class="card-back-row text-bold">
                    {{ $t('home_blocks.close_or_back_text_1') }}
                  </div>
                  <div class="card-back-row text-bold">
                    {{ $t('home_blocks.close_or_back_text_2') }}
                  </div>
                  <div class="card-back-row text-bold">
                    {{ $t('home_blocks.close_or_back_text_3') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="home--block-wrapper blocks-big">
            <div class="block-header-wrapper">
              <div class="block-header">
                <div class="block-title">
                  <div class="car-text">
                    <span class="primary-color"> car </span>
                    {{ $t('home_blocks.reception') }}
                  </div>
                </div>
                <div class="block-subtitle">
                  {{ $t('home_blocks.reception_text') }}
                </div>
              </div>
            </div>
            <div
              class="block-body"
              :style="{ backgroundImage: 'url(assets/home/blocks/reception.webp)' }"
            >
              <button>
                <span class="fa-layers fa-fw">
                  <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                  <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                </span>
              </button>
              <div class="card-back">
                <div class="card-back-wrapper pt-5">
                  <div class="card-back-row">
                    <span class="text-bold">
                      {{ $t('home_blocks.reception_back_text_1') }}
                    </span>
                    {{ $t('home_blocks.reception_back_text_1_more') }}
                  </div>
                  <div class="card-back-row">
                    {{ $t('home_blocks.reception_back_text_2') }}
                  </div>
                  <div class="card-back-row">
                    {{ $t('home_blocks.reception_back_text_3') }}
                    <span class="text-bold">
                      {{ $t('home_blocks.reception_back_text_3_more') }}
                    </span>
                  </div>
                  <div class="card-back-row">
                    {{ $t('home_blocks.reception_back_text_4') }}
                  </div>
                  <div class="card-back-row">
                    {{ $t('home_blocks.reception_back_text_5') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="home--block-wrapper blocks-small">
            <div class="block-header-wrapper">
              <div class="block-header">
                <div class="block-title">
                  <div class="car-text">
                    <span class="primary-color"> car </span>
                    {{ $t('home_blocks.extension') }}
                  </div>
                </div>
                <div class="block-subtitle">
                  {{ $t('home_blocks.extension_text') }}
                </div>
              </div>
            </div>
            <div
              class="block-body"
              :style="{ backgroundImage: 'url(assets/home/blocks/cita4.webp)' }"
            >
              <button>
                <span class="fa-layers fa-fw">
                  <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                  <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                </span>
              </button>
              <div class="card-back pt-3">
                <div class="card-back-wrapper">
                  <div class="card-back-row text-bold">
                    {{ $t('home_blocks.extension_back') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home--block-wrapper second-block blocks-small">
            <div class="block-header-wrapper">
              <div class="block-header">
                <div class="block-title">
                  <div class="car-text">
                    <span class="primary-color"> car </span>
                    {{ $t('home_blocks.invoice') }}
                  </div>
                </div>
                <div class="block-subtitle">
                  {{ $t('home_blocks.invoice_text') }}
                </div>
              </div>
            </div>
            <div
              class="block-body"
              :style="{ backgroundImage: 'url(assets/home/blocks/cita5.webp)' }"
            >
              <button>
                <span class="fa-layers fa-fw">
                  <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                  <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                </span>
              </button>
              <div class="card-back">
                <div class="card-back-wrapper">
                  <div class="card-back-row text-bold no-pad">
                    {{ $t('home_blocks.invoice_back_text_1') }}
                  </div>
                  <div class="card-back-row text-bold no-pad">
                    {{ $t('home_blocks.invoice_back_text_2') }}
                  </div>
                  <div class="card-back-row text-bold no-pad">
                    {{ $t('home_blocks.invoice_back_text_3') }}
                  </div>
                  <div class="card-back-row text-bold no-pad">
                    {{ $t('home_blocks.invoice_back_text_4') }}
                  </div>
                  <div class="card-back-row text-bold no-pad">
                    {{ $t('home_blocks.invoice_back_text_5') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-block-slider-mobile">
        <div class="custom-carousel-wrapper">
          <div class="custom-carousel-inner-wrapper home-block-carousel">
            <carousel
              :items-to-show="1"
              :wrap-around="true"
              :mouse-drag="true"
              :touch-drag="true"
              :autoplay="4000"
            >
              <slide :key="1">
                <div class="home--block-wrapper blocks-small">
                  <div class="block-header-wrapper">
                    <div class="block-header">
                      <div class="block-title">
                        <div class="car-text">
                          <span class="primary-color"> car </span>
                          {{ $t('home_blocks.appointment') }}
                        </div>
                      </div>
                      <div class="block-subtitle">
                        {{ $t('home_blocks.appointment_text') }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="block-body"
                    :style="{ backgroundImage: 'url(assets/home/blocks/cita.webp)' }"
                  >
                    <button>
                      <span class="fa-layers fa-fw">
                        <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                        <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                      </span>
                    </button>
                    <div class="card-back">
                      <div class="card-back-wrapper">
                        <div class="card-back-row">
                          <span class="text-bold">
                            {{ $t('home_blocks.appointment_back_text_1') }}
                          </span>
                          {{ $t('home_blocks.appointment_back_text_1_more') }}
                        </div>
                        <div class="card-back-row">
                          <span class="text-bold">
                            {{ $t('home_blocks.appointment_back_text_2') }}
                          </span>
                          {{ $t('home_blocks.appointment_back_text_2_more') }}
                        </div>
                        <div class="card-back-row">
                          <span class="text-bold">
                            {{ $t('home_blocks.appointment_back_text_3') }}
                          </span>
                          {{ $t('home_blocks.appointment_back_text_3_more') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide :key="2">
                <div class="home--block-wrapper blocks-big">
                  <div class="block-header-wrapper">
                    <div class="block-header">
                      <div class="block-title">
                        <div class="car-text">
                          <span class="primary-color"> car </span>
                          {{ $t('home_blocks.close_or') }}
                        </div>
                      </div>
                      <div class="block-subtitle">
                        {{ $t('home_blocks.close_or_text') }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="block-body"
                    :style="{ backgroundImage: 'url(assets/home/blocks/cita3.webp)' }"
                  >
                    <button>
                      <span class="fa-layers fa-fw">
                        <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                        <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                      </span>
                    </button>
                    <div class="card-back">
                      <div class="card-back-wrapper pt-2">
                        <div class="card-back-row text-bold">
                          {{ $t('home_blocks.close_or_back_text_1') }}
                        </div>
                        <div class="card-back-row text-bold">
                          {{ $t('home_blocks.close_or_back_text_2') }}
                        </div>
                        <div class="card-back-row text-bold">
                          {{ $t('home_blocks.close_or_back_text_3') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide :key="3">
                <div class="home--block-wrapper blocks-small">
                  <div class="block-header-wrapper">
                    <div class="block-header">
                      <div class="block-title">
                        <div class="car-text">
                          <span class="primary-color"> car </span>
                          {{ $t('home_blocks.reception') }}
                        </div>
                      </div>
                      <div class="block-subtitle">
                        {{ $t('home_blocks.reception_text') }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="block-body"
                    :style="{ backgroundImage: 'url(assets/home/blocks/reception.webp)' }"
                  >
                    <button>
                      <span class="fa-layers fa-fw">
                        <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                        <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                      </span>
                    </button>
                    <div class="card-back">
                      <div class="card-back-wrapper">
                        <div class="card-back-row little-row">
                          <span class="text-bold">
                            {{ $t('home_blocks.reception_back_text_1') }}
                          </span>
                          {{ $t('home_blocks.reception_back_text_1_more') }}
                        </div>
                        <div class="card-back-row little-row">
                          {{ $t('home_blocks.reception_back_text_2') }}
                        </div>
                        <div class="card-back-row little-row">
                          {{ $t('home_blocks.reception_back_text_3') }}
                          <span class="text-bold">
                            {{ $t('home_blocks.reception_back_text_3_more') }}
                          </span>
                        </div>
                        <div class="card-back-row little-row">
                          {{ $t('home_blocks.reception_back_text_4') }}
                        </div>
                        <div class="card-back-row little-row">
                          {{ $t('home_blocks.reception_back_text_5') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide :key="4">
                <div class="home--block-wrapper blocks-small">
                  <div class="block-header-wrapper">
                    <div class="block-header">
                      <div class="block-title">
                        <div class="car-text">
                          <span class="primary-color"> car </span>
                          {{ $t('home_blocks.extension') }}
                        </div>
                      </div>
                      <div class="block-subtitle">
                        {{ $t('home_blocks.extension_text') }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="block-body"
                    :style="{ backgroundImage: 'url(assets/home/blocks/cita4.webp)' }"
                  >
                    <button>
                      <span class="fa-layers fa-fw">
                        <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                        <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                      </span>
                    </button>
                    <div class="card-back pt-3">
                      <div class="card-back-wrapper">
                        <div class="card-back-row text-bold">
                          {{ $t('home_blocks.extension_back') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide :key="5">
                <div class="home--block-wrapper second-block blocks-small">
                  <div class="block-header-wrapper">
                    <div class="block-header">
                      <div class="block-title">
                        <div class="car-text">
                          <span class="primary-color"> car </span>
                          {{ $t('home_blocks.invoice') }}
                        </div>
                      </div>
                      <div class="block-subtitle">
                        {{ $t('home_blocks.invoice_text') }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="block-body"
                    :style="{ backgroundImage: 'url(assets/home/blocks/cita5.webp)' }"
                  >
                    <button>
                      <span class="fa-layers fa-fw">
                        <font-awesome-icon icon="fa-solid fa-circle" style="color: black" />
                        <font-awesome-icon icon="fa-solid fa-plus" style="color: white" />
                      </span>
                    </button>
                    <div class="card-back">
                      <div class="card-back-wrapper">
                        <div class="card-back-row text-bold no-pad">
                          {{ $t('home_blocks.invoice_back_text_1') }}
                        </div>
                        <div class="card-back-row text-bold no-pad">
                          {{ $t('home_blocks.invoice_back_text_2') }}
                        </div>
                        <div class="card-back-row text-bold no-pad">
                          {{ $t('home_blocks.invoice_back_text_3') }}
                        </div>
                        <div class="card-back-row text-bold no-pad">
                          {{ $t('home_blocks.invoice_back_text_4') }}
                        </div>
                        <div class="card-back-row text-bold no-pad">
                          {{ $t('home_blocks.invoice_back_text_5') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> </slide
              >r-link>
              <template #addons>
                <pagination />
              </template>
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.home--blocks {
  .home--blocks-wrapper {
    max-width: 1040px;
    margin: 0 auto;
    padding-top: 115px;
    padding-bottom: 180px;
    .home--blocks-row {
      display: flex;
      .home--block-wrapper {
        background-color: #edeff2;
        border-radius: 20px;
        position: relative;
        max-width: 324px;
        &.blocks-small {
          height: 320px;
        }
        &.blocks-big {
          height: 670px;
        }
        &.second-block {
          margin-top: 30px;
        }
        .block-header-wrapper {
          height: 128px;
          padding: 28px;
          .block-title {
            font-size: 20px;
            letter-spacing: -1px;
            font-family: 'CircularStd-Black';
            padding-bottom: 15px;
          }
          .block-subtitle {
            font-size: 14px;
          }
        }
        .home--blocks-desktop {
          display: block;
        }
        .home-block-slider-mobile {
          display: none;
        }
        .block-body {
          background-repeat: no-repeat;
          background-size: cover;
          height: calc(100% - 128px);
          width: 100%;
          position: relative;
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
          cursor: pointer;
          img {
            width: 100%;
            border-bottom-left-radius: 18px;
            border-bottom-right-radius: 18px;
          }
          button {
            border: none;
            color: black;
            position: absolute;
            bottom: 10px;
            right: 14px;
            background-color: transparent;
            cursor: pointer;
            z-index: 2;
            .fa-circle {
              font-size: 24px;
            }
            .fa-plus {
              font-size: 16px;
              left: 4px;
              animation: opacity;
              animation-iteration-count: infinite;
              animation-duration: 1s;
            }
          }
          .card-back {
            background-color: #edeff2;
            font-size: 14px;
            padding: 5px 28px;
            cursor: pointer;
            opacity: 0;
            transition: opacity 0.2s ease-out;
            .card-back-wrapper {
              .card-back-row {
                padding-bottom: 15px;
                &.no-pad {
                  padding-bottom: 0;
                }
              }
            }
          }
          &:hover .card-back {
            height: 100%;
            border-bottom-left-radius: 17px;
            border-bottom-right-radius: 17px;
            opacity: 1;
          }
          &:hover button span .fa-plus {
            transform: rotate(45deg);
            transition: transform 0.5s;
          }
        }
      }
    }
    .home--blocks-titles {
      padding-bottom: 92px;
      .home--block-title {
        font-size: 40px;
        letter-spacing: -2px;
        font-family: 'CircularStd-Black';
        text-align: center;
        padding-bottom: 2px;
      }
      .home--block-subtitle {
        text-align: center;
        font-size: 16px;
        letter-spacing: -0.8px;
      }
    }
  }
}
.home-block-slider-mobile {
  display: none;
}
@media screen and (max-width: 1000px) {
  .home--blocks-desktop {
    display: none;
  }
  .home-block-slider-mobile {
    display: block;
  }
  .home--blocks .home--blocks-wrapper .home--blocks-row {
    &.home--blocks-desktop {
      display: none;
    }
  }
  .home--blocks {
    .home--blocks-wrapper {
      max-width: 1040px;
      margin: 0 auto;
      padding-top: 115px;
      padding-bottom: 180px;
      .home-block-slider-mobile {
        display: block;
        .home--block-wrapper {
          background-color: #edeff2;
          border-radius: 20px;
          position: relative;
          max-width: 324px;
          &.blocks-small {
            height: 320px;
          }
          &.blocks-big {
            height: 320px;
          }
          &.second-block {
            margin-top: 30px;
          }
          .block-header-wrapper {
            height: 128px;
            padding: 28px;
            .block-title {
              font-size: 20px;
              letter-spacing: -1px;
              font-family: 'CircularStd-Black';
              padding-bottom: 15px;
            }
            .block-subtitle {
              font-size: 14px;
            }
          }
          .home--blocks-desktop {
            display: block;
          }
          .home-block-slider-mobile {
            display: none;
          }
          .block-body {
            background-repeat: no-repeat;
            background-size: cover;
            height: calc(100% - 128px);
            width: 100%;
            position: relative;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
            cursor: pointer;
            img {
              width: 100%;
              border-bottom-left-radius: 18px;
              border-bottom-right-radius: 18px;
            }
            button {
              border: none;
              color: black;
              position: absolute;
              bottom: 10px;
              right: 14px;
              background-color: transparent;
              cursor: pointer;
              z-index: 2;
              .fa-circle {
                font-size: 24px;
              }
              .fa-plus {
                font-size: 16px;
                padding-left: 4px;
              }
            }
            .card-back {
              background-color: #edeff2;
              font-size: 14px;
              padding: 5px 28px;
              cursor: pointer;
              opacity: 0;
              transition: opacity 1s ease-out;
              .card-back-wrapper {
                .card-back-row {
                  padding-bottom: 15px;
                  &.no-pad {
                    padding-bottom: 0;
                  }
                }
              }
            }
            &:hover .card-back {
              height: 100%;
              border-bottom-left-radius: 17px;
              border-bottom-right-radius: 17px;
              opacity: 1;
            }
            &:hover button .fa-plus {
              transform: rotate(45deg);
            }
          }
        }
      }
      .home--blocks-titles {
        padding-bottom: 92px;
        .home--block-title {
          font-size: 40px;
          letter-spacing: -2px;
          font-family: 'CircularStd-Black';
          text-align: center;
          padding-bottom: 2px;
        }
        .home--block-subtitle {
          text-align: center;
          font-size: 16px;
          letter-spacing: -0.8px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .home--blocks .home--blocks-wrapper .home-block-slider-mobile .home--block-wrapper .block-body .card-back .card-back-wrapper .card-back-row {
    padding-bottom: 5px;
  }
}
</style>
